import { ICostsTag } from "@interfaces/admin/costsTag";
import { authApi } from "@RTKQuery/basic";

const costsTagsAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAllCostsTags: build.query<ICostsTag[], void>({
            query: () => "cost_tags",
        }),
        createCostsTag: build.mutation<ICostsTag, {
            name: ICostsTag["name"]
        }>({
            query: (body) => ({
                url: "cost_tags",
                method: "POST",
                body
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    dispatch(costsTagsAuthApi.util.updateQueryData("getAllCostsTags", undefined, (draft) => {
                        if (!draft.some(item => item.id === data.id)) {
                            draft.push(data)
                        }
                    }))
                } catch { }
            },
        }),
        deleteCostsTag: build.mutation<boolean, ICostsTag["id"]>({
            query: (cost_tag_id) => ({
                url: "cost_tags/" + cost_tag_id,
                method: "PUT",
            }),
            async onQueryStarted(cost_tag_id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    dispatch(costsTagsAuthApi.util.updateQueryData("getAllCostsTags", undefined, (draft) => {
                        return draft.filter(item => item.id !== cost_tag_id)
                    }))
                } catch { }
            },
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAllCostsTagsQuery,
    useCreateCostsTagMutation,
    useDeleteCostsTagMutation
} = costsTagsAuthApi;